import { Formatter } from "src/app/utils/formatter";

export class CotacoesPDocs {
    id: string;
    idIntegracao: string; //id da cotação (idIntegracao no Negocio do p-docs)
    modelo: string;
    placa: string;
    ramo: number; //2 residencial, 31 auto
    seguradoNome: string;
    seguradoCpfCnpj: string;
    fone1: string;
    status: number; // 1 - não calculado, 2 - calculado, 3 - calculando, 4 - fechado, 5 - perdido  
    tipo: string; //tipo de veículo ramo auto | v - auto, m - moto, c - caminhão
    vigenciaIni: string;
    vigenciaFim: string;
    createdAt: string;

    //residencial
    imovelCidade: string;
    imovelConstrucao: number;
    imovelOcupacao: number;
    imovelTipoResidencia: number;
    imovelUF: string;

    //bike
    marca: string;

    getTipoAluguelTxt() {
        const tipos: {[key: string]: string} = {
            '1': "Apartamento",
            '2': "Casa",
            '3': "Sala Comercial",
            '4': "Loja",
            '5': "Prédio",
            '6': "Galpão"
        }

        if (tipos[this.tipo]) {
            return tipos[this.tipo];
        } else {
            return '';
        }
    }

    getTipoResidTxt(){
        if(this.imovelTipoResidencia == 1) {
            return "Casa";
        }   
        else if (this.imovelTipoResidencia == 2) {
            return 'Casa em Condomínio Fechado';
        }
        else if (this.imovelTipoResidencia == 3) {
            return 'Apartamento';
        }else{
            return '';
        }
    }
    
    getMarcaBikeTxt() {
        const marcas = {
            "1": "Caloi",
            "2": "Cannondale",
            "3": "Oggi",
            "4": "Scott",
            "5": "Specialized",
            "6": "Trek",
            "7": "BMC",
            "8": "Pinarello",
            "9": "Eddy Merckx",
            "10": "Giant",
            "11": "Raleigh",
            "12": "GT",
            "13": "Focus",
            "14": "Felt",
            "15": "Cervelo",
            "16": "Bianchi",
            "17": "Jamis",
            "18": "Surly",
            "19": "Diamondback",
            "20": "Mérida",
            "21": "Kona",
            "22": "Fuji",
            "23": "Dahon",
            "24": "Santa Cruz",
            "25": "Marin",
            "26": "Sense",
            "27": "Colnago",
            "99": "Outras"
        }
        if (marcas[this.marca]) {
            return marcas[this.marca]
        } else {
            return '';
        }
    }

    getTipoBikeTxt() {
        const tipos = {
            "1": "BMX",
            "2": "Dobrável",
            "3": "Downhill",
            "4": "Elétrica",
            "5": "Elétrica e Dobrável",
            "6": "Fixa",
            "7": "Hand Bike",
            "8": "Mountain Bike",
            "9": "Reclinada",
            "10": "Speed",
            "11": "Trial",
            "12": "Urbana"
        }
        if (tipos[this.tipo]) {
            return tipos[this.tipo]
        } else {
            return '';
        }
    }

    getImovelConsTxt() {
        if(this.imovelConstrucao == 1) {
            return 'Alvenaria';
        }   
        else if (this.imovelConstrucao == 2) {
            return 'Madeira';
        }
        else if (this.imovelConstrucao == 3) {
            return 'Mista';
        }else{
            return '';
        }
    }

    getAllCotacaoStatus() {
        return [
            { value: 1, viewValue: 'Em edição' },
            { value: 2, viewValue: 'Calculados' },
            { value: 3, viewValue: 'Calculando' },
            { value: 4, viewValue: 'Negócios Fechados' },
            { value: 5, viewValue: 'Negócios Perdidos' },
        ]
    }

    getAllCotacaoPeriodos() {
        return [
            { value: 99999, viewValue: 'Todo o período' },
            { value: 7, viewValue: 'Últimos 7 dias ' },
            { value: 30, viewValue: 'Últimos 30 dias ' },
            { value: 365, viewValue: 'Último ano' },
        ]
    }

    imovelOcupacaoTxt () {
        if(this.imovelOcupacao == 1) {
            return 'Habitual';
        }   
        else if (this.imovelOcupacao == 2) {
            return 'Veraneio';
        }
        else if (this.imovelOcupacao == 3) {
            return 'Desocupado';
        }else{
            return ''
        }
    }

    getIcon(){
        if(this.ramo == 31){
            if (this.tipo == 'v') {           
                return 'car-hatchback';
            } else if (this.tipo == 'm') {           
                return 'motorbike';
            } else if (this.tipo == 'c') {           
                return 'truck';
            } else {           
                return 'help-circle';
            }
        }else if(this.ramo == 2){
            return 'home';
        }else if(this.ramo == 91){
            return 'cards-heart';
        }else if(this.ramo == 93){
            return 'vida-global';
        }else if(this.ramo == 81){
            return 'account-injury';
        }else if(this.ramo == 69){
            return 'bag-suitcase';
        }else if(this.ramo == 18){
            return 'factory';
        }else if(this.ramo == 16){
            return 'domain';
        }else if(this.ramo == 46){
            return 'key-chain-variant';
        }else if(this.ramo == 711){
            return 'bicycle';
        }else if(this.ramo == 100){
            return 'smartphone';
        }else{
            return 'help-circle';
        }        
    }

    getIconStatus(){
        if(this.status == 1){
            return {icon: 'editando', color: 'cStatCinza'};
        }else if(this.status == 2){
            return {icon: 'calculado', color: 'cStatAzul'};
        }else if(this.status == 3){
            return {icon: 'calculando', color: 'cStatLaranja'};
        }else if(this.status == 4){
            return {icon: 'fechado_concluido', color: 'cStatVerde'};
        }else if(this.status == 5){
            return {icon: 'negocio_perdido', color: 'cStatVermelho'};
        }else{
            return {icon: 'alert-octagram', color: 'cStatCinza'};
        }
    }

    getRotulo(){
        if(this.ramo == 31){
            if (this.tipo == 'v') {
                return 'Automóvel';
            } else if (this.tipo == 'm') {
                return 'Moto';
            } else if (this.tipo == 'c') {
                return 'Caminhão';           
            } else {
                return '';           
            }
        }else if(this.ramo == 2){
            return 'Residencial';
        }else if(this.ramo == 91){
            return 'Vida';
        }else if(this.ramo == 93){
            return 'Vida Global';
        }else if(this.ramo == 81){
            return 'Acidentes Pessoais';
        }else if(this.ramo == 69){
            return 'Viagem';
        }else if(this.ramo == 18){
            return 'Empresarial';
        } else if(this.ramo == 16){
            return 'Condomínio';
        }else if(this.ramo == 46){
            return 'Aluguel';
        }else if(this.ramo == 711){
            return 'Bike';
        } else if(this.ramo == 100){
            return 'Celular';
        } else {
            return '';
        }        
    }    
   
    getLink(){
        if (this.status == 1 && this.ramo == 31) {
            return `/cotacao/auto/formulario/${this.idIntegracao}`;
        }         
        else if ((this.status != 1) && this.ramo == 31) {
            return `/cotacao/auto/resultados/${this.idIntegracao}`;
        }        
        else if (this.status == 1 && this.ramo == 2) {
        // else if (this.status == 1 && this.ramo == 2) {
            return `/cotacao/residencial/formulario/${this.idIntegracao}`;
        } 
        else if ((this.status != 1) && this.ramo == 2) {
            return `/cotacao/residencial/resultados/${this.idIntegracao}`;
        }
        else if (this.status == 1 && this.ramo == 91) {
            return `/cotacao/vida/formulario/${this.idIntegracao}`;
        }
        else if ((this.status != 1) && this.ramo == 91) {
        // else if ((this.status == 2 || this.status == 3) && this.ramo == 91) {
            return `/cotacao/vida/resultados/${this.idIntegracao}`;
        }
        else if (this.status == 1 && this.ramo == 93) {
            return `/cotacao/vida_global/formulario/${this.idIntegracao}`;
        }
        else if ((this.status != 1) && this.ramo == 93) {
            return `/cotacao/vida_global/resultados/${this.idIntegracao}`;
        }
        else if (this.status == 1 && this.ramo == 81) {
            return `/cotacao/acidentes_pessoais/formulario/${this.idIntegracao}`;
        }
        else if ((this.status != 1) && this.ramo == 81) {
            return `/cotacao/acidentes_pessoais/resultados/${this.idIntegracao}`;
        }
        else if (this.status == 1 && this.ramo == 69) {
            return `/cotacao/viagem/formulario/${this.idIntegracao}`;
        }
        else if ((this.status != 1) && this.ramo == 69) {
            return `/cotacao/viagem/resultados/${this.idIntegracao}`;
        }
        else if (this.status == 1 && this.ramo == 18) {
            return `/cotacao/empresarial/formulario/${this.idIntegracao}`;
        }
        else if ((this.status != 1) && this.ramo == 18) {
            return `/cotacao/empresarial/resultados/${this.idIntegracao}`;
        } 
        else if (this.status == 1 && this.ramo == 16) {
            return `/cotacao/condominio/formulario/${this.idIntegracao}`;
        }
        else if ((this.status != 1) && this.ramo == 16) {
            return `/cotacao/condominio/resultados/${this.idIntegracao}`;
        } 
        else if (this.status == 1 && this.ramo == 46) {
            return `/cotacao/aluguel/formulario/${this.idIntegracao}`;
        }
        else if ((this.status != 1) && this.ramo == 46) {
            return `/cotacao/aluguel/resultados/${this.idIntegracao}`;
        } 
        else if (this.status == 1 && this.ramo == 711) {
            return `/cotacao/bike/formulario/${this.idIntegracao}`;
        }
        else if ((this.status != 1) && this.ramo == 711) {
            return `/cotacao/bike/resultados/${this.idIntegracao}`;
        }
        else if (this.status == 1 && this.ramo == 100) {
            return `/cotacao/celular/formulario/${this.idIntegracao}`;
        }
        else if ((this.status != 1) && this.ramo == 100) {
            return `/cotacao/celular/resultados/${this.idIntegracao}`;
        }
    }   

    getRotuloStatus(){
        if(this.status == 1){
            return 'Em edição';
        }else if(this.status == 2){
            return 'Calculado';
        }else if(this.status == 3){
            return 'Calculando';
        }else if(this.status == 4){
            return 'Fechado';
        }else if(this.status == 5){
            return 'Perdido';
        }else{
            return 'Erro';
        }
    }

    getVigIni(){
        return this.vigenciaIni ? Formatter.dateDDMMAAAA(this.vigenciaIni) : ''; 
    }

    getVigFim(){
        return this.vigenciaFim ? Formatter.dateDDMMAAAA(this.vigenciaFim) : '';
    }

    getPeriodoVigencia(ramo){
        if (ramo == 91 || ramo == 93 || ramo == 81) {
            return this.vigenciaIni ? Formatter.dateDDMMAAAA(this.vigenciaIni) : '';
        } else {
            return this.vigenciaIni && this.vigenciaFim
            ? Formatter.dateDDMMAAAA(this.vigenciaIni) + ' à ' + Formatter.dateDDMMAAAA(this.vigenciaFim)
            : '';
        }
        
    }

    getData() {
        return this.createdAt ? Formatter.dateDDMMAAAA(this.createdAt) : ''; 
    }

    deserialize(input: any): this {        
        Object.assign(this, input);
        return this;
    }
    
    
}